// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "screen and (max-width: 320px)";
var _4 = "header-3eWuH";
var _5 = "header_mobileFullScreen-2_hTr";
var _6 = "text-1ZkRf";
var _7 = "body-2F_tH";
var _8 = "summary-2yL6N";
var _9 = "summary__seats-25CR-";
var _a = "summary__price-WP-Qs";
export { _1 as "__esModule", _2 as "mobile", _3 as "iphone5", _4 as "header", _5 as "header_mobileFullScreen", _6 as "text", _7 as "body", _8 as "summary", _9 as "summary__seats", _a as "summary__price" }
export default { "__esModule": _1, "mobile": _2, "iphone5": _3, "header": _4, "header_mobileFullScreen": _5, "text": _6, "body": _7, "summary": _8, "summary__seats": _9, "summary__price": _a }
